import { render, staticRenderFns } from "./QuestionWrapper.vue?vue&type=template&id=43b56496"
import script from "./QuestionWrapper.vue?vue&type=script&lang=js"
export * from "./QuestionWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports